import { Component, OnInit, ViewChild, Renderer2, AfterViewInit, Self } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToasterService } from 'src/app/services/toater.service';
import { environment } from 'src/environments/environment';
import { Permission } from 'src/app/helpers/enums/roles/permission';
import { HasPermission } from 'src/app/helpers/has-permission.helper';
import { FolderTemplateService } from 'src/app/services/foldertemplate.service';

@Component({
  selector: 'app-folder-template-list',
  templateUrl: './folder-template-list.component.html',
  styleUrls: ['./folder-template-list.component.css']
})
export class FolderTemplateListComponent implements OnInit, AfterViewInit {

  constructor(private tosterService: ToasterService,
              private renderer: Renderer2,
              private router: Router,
              private folderTemplateService: FolderTemplateService) { }

  // for filters
  formodel: string;
  frm: FormGroup;

  @BlockUI('container-blockui-manage') blockUI: NgBlockUI;
  @ViewChild(DataTableDirective, { static: false }) datatableElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  rowIndex = 0;
  dtRendered = true;
  visibleColumns = [];
  isDtVisible = false;
  isDtInitialized = false;
  permissionType = Permission;
  hasPermissionType = HasPermission;

  users: any = [];
  isBulkActionDisabled = true;

  private getSelectedIds(): any[] {
    const foldertemplateIds = [];
    const rows = this.dtInstance.rows().nodes();
    [...rows.$('.checked')].forEach(item => foldertemplateIds.push($(item).val()));
    return foldertemplateIds;
  }

  ngOnInit(): void {
    this.initDataTable();
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dtInstance = dtInstance;
      const header = dtInstance.columns().header();
      $(header).find('[action-type="select-unSelect-all"]')
        .off('change').on('change', (e: any) => {
          this.onSelectAllRow(e.target.checked);
        });
    });
  }

  private initDataTable(): void {
    const self = this;
    this.dtOptions = {
      dom: '<"top">rt<"bottom"lip><"clear">',
      serverSide: true,
      destroy: true,
      processing: true,
      language: {
        loadingRecords: '&nbsp;',
        processing: '<div class="block-ui-spinner"><div class="loader"></div></div>',
        paginate: {
          first: '<i class="fa fa-angle-double-left">',
          last: '<i class="fa fa-angle-double-right">',
          previous: '<i class="fa fa-angle-left">',
          next: '<i class="fa fa-angle-right">'
        }
      },
      displayStart: 0,
      paging: true,
      pagingType: 'full_numbers',
      pageLength: environment.paging.defaultPageSize,
      lengthMenu: environment.paging.lengthMenu,
      order: [[1, 'asc']],
      autoWidth: false,
      ajax: (dataTablesParameters: any, callback) => {
        self.blockUI.start();
        self.folderTemplateService.query(dataTablesParameters)
          .subscribe(resp => {

            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: resp.data
            });
            self.blockUI.stop();
          }, error => {
            self.tosterService.ProcessErrorResponse(error);
            self.blockUI.stop();
          }, () => { this.toggleControls(); });
      },
      columns: [
        {
          data: null,
          title: `<input type="checkbox" action-type="select-unSelect-all" />`,
          name: 'select',
          orderable: false,
          render: (data, type, row) => {
            return `<input type='checkbox' value = '${row.id}' action-type= "select-row"/>`;
          }
        },
        {
          data: 'name',
          title: 'Name',
          render: (data, type, row) => {
            return `${row.name}`;
          }
        },
        {
          data: 'accessGroupId',
          title: 'Access Group',
          render: (data,type,row) =>{
            return `<div class="note-text-wrap">${row.accessGroup?.name}</div>`
          }
        },
        {
          data: 'defaultNote',
          title: 'Notes',
          render: (data,type,row) =>{
            return `<div class="note-text-wrap">${row.defaultNote}</div>`
          }
        },
        {
          data: null,
          title: 'Used In',
          orderable: false,
          searchable: false,
          render: (data,type,row) =>{
            return `<div class="note-text-wrap">${row.caseTypeFolderTemplates}</div>`
          }
        },
        {
          data: 'name',
          title: (HasPermission.validate([Permission.DeleteClients]) || HasPermission.validate([Permission.EditClients])) ? 'Action' : '',
          name: 'action',
          orderable: false,
          render: (data, type, row) => {
            const disabled = '';
            const permissionDelete = HasPermission.validate([Permission.DeleteClients]);
            const permissionEdit = HasPermission.validate([Permission.EditClients]);
            const deleteButton = permissionDelete ? `<button  class='btn del-btn btn-lg btn-table' action-type="delete">
            <i  class='align-middle rounded-circle bg-delete bg-delete-btn fas fa-trash-alt fa-1x p-2 text-danger'></i>
              </button>`
              : '';
            const undeleteButton = permissionDelete ? `<button  class='btn del-btn btn-lg btn-table' action-type="un-delete">
              <i  class='align-middle rounded-circle bg-delete bg-delete-btn fas fa-trash-restore-alt  fa-1x p-2 text-danger'></i>
              </button>`
              : '';
            const editButton = !row.isDeleted && permissionEdit
              ? `<button  class='btn del-btn btn-lg btn-table' action-type="edit" alt="undelete">
              <i class='align-middle rounded-circle bg-delete bg-delete-btn fas fa-pencil-alt btn-edit fa-1x p-2'></i>
                </button>`
              : '';

            return `<div class='fa-edit'>${editButton}
                    ${row.isDeleted ? undeleteButton : deleteButton}
                    </div>`;
          }
        },
      ],
      rowCallback: (row, data: any) => {
        const _row = $(row);

        // _row.find('[action-type="link-detail"]')
        //   .off('click')
        //   .on('click', () => {
        //     self.linkDetail(data.id);
        //   });
        _row.find('[action-type="edit"]')
          .off('click')
          .on('click', () => {
            self.router.navigate(['/setting/cases/edit-folder-template', data.id]);
          });
        _row.find('[action-type="delete"]')
          .off('click')
          .on('click', () => {
            self.delete([data.id]);
          });
        _row.find('[action-type="un-delete"]')
          .off('click')
          .on('click', () => {
            self.unDelete([data.id]);
          });
        _row.find('[action-type = "select-row"]')
          .off('click').on('click', (e: any) => {
            this.onSelectedOrUnselectRow(e);
          });
      },
      // Use this attribute to enable the responsive extension
      responsive: true,
    };
  }

  onSelectedOrUnselectRow(event: any): void {
    if (event.target.checked) {
      this.renderer.addClass(event.target, 'checked');
    } else {
      this.renderer.removeClass(event.target, 'checked');
    }
    this.toggleControls();
  }

  private toggleControls(): void {
    this.setSelectAllCheckbox();
    this.enableOrDisableDeleteButton();
  }
  private setSelectAllCheckbox(): void {
    const rows = this.dtInstance.rows().nodes();
    if (rows !== null) {
      const header = this.dtInstance.columns().header();
      const selectAllElement = $(header).find('[action-type="select-unSelect-all"]')[0] as any;
      const selelectedRows = [...rows.$('[action-type= "select-row"]')];
      selectAllElement.checked = selectAllElement != null && selelectedRows.length > 0
        && selelectedRows.every(row => row.classList.contains('checked'));
    }
  }

  onBulkDelete(): void {
    this.delete(this.getSelectedIds());
  }

  private showColumns(): void {
    const visibleColumnsSelector = this.visibleColumns.map(item => `${item.toLowerCase()}:name`)
      .concat(['action:name', 'select:name']);
    const visibleIndexes = this.dtInstance.columns(visibleColumnsSelector).indexes().toArray();
    this.dtInstance.columns().every(function() {
      const colIndex = this.index();
      this.visible(visibleIndexes.includes(colIndex));
    });
    this.isDtVisible = true;
  }

  private reloadDataTable(): void {
    this.dtInstance.ajax.reload();
    this.resetSelectAllCheckBox();
  }

  delete(ids: number[]): void {
    if (!confirm('Are you sure you want to delete selected Folder Template(s)?')) {
      return;
    }
    this.blockUI.start();
    this.folderTemplateService.deleteFolderTemplate(ids).subscribe(() => {
      this.reloadDataTable();
      this.tosterService.success('Folder template has been deleted successfully.');
      this.blockUI.stop();
    }, error => {
      this.tosterService.ProcessErrorResponse(error);
      this.blockUI.stop();
    });
  }

  unDelete(ids: number[]): void {
    if (!confirm('Are you sure you want to undelete selected Folder Template(s)?')) {
      return;
    }
    this.blockUI.start();
    this.folderTemplateService.undeleteFolderTemplate(ids).subscribe(() => {
      this.reloadDataTable();
      this.tosterService.success('Folder template has been undeleted successfully.');
      this.blockUI.stop();
    }, error => {
      this.tosterService.ProcessErrorResponse(error);
      this.blockUI.stop();
    });
  }

  onSelectAllRow(isChecked: boolean): void {
    const rows = this.dtInstance.rows().nodes();
    const checkBoxes = [...rows.$('[action-type= "select-row"]')];
    if (isChecked) {
      checkBoxes.forEach(row => {
        this.renderer.addClass(row, 'checked');
        (row as HTMLInputElement).checked = true;
      });
    } else {
      checkBoxes.forEach(row => {
        this.renderer.removeClass(row, 'checked');
        (row as HTMLInputElement).checked = false;
      });
    }
    this.enableOrDisableDeleteButton();
  }
  private enableOrDisableDeleteButton(): void {

    const rows = this.dtInstance.rows().nodes();
    this.isBulkActionDisabled = [...rows.$('.checked')].length === 0;
  }

  linkDetail(id: number): void {
    this.router.navigate(['/setting/cases/folder-templates-list',id]);
  }

  private resetSelectAllCheckBox(): void {
    const header = this.dtInstance.columns().header();
    const selectAllElement = $(header).find('[action-type="select-unSelect-all"]')[0] as any;
    if (selectAllElement && selectAllElement.checked) {
      selectAllElement.checked = false;
    }
  }

}
